export default {
  heading: {
    widgetName: "category",
    widgetID: "107",
    cardCount: "5",
    layoutName: "lob_widget",
    headline: "SHOP DUTY FREE NOW",
    subHeadline: "",
    showMoreURL: "",
    gtmParameters: {
      event: "trackEventNoEcommerce",
      eventActionClick: "click",
      eventActionView: "view",
      eventCategory: `certifiedsuper | Discover Certified Super Food outlets`,
      eventLabelCardClick: `certifiedsuper | {{cardtitle}} | {{cardwidth}} | {{cardposition}} | {{redirecturl}}`,
      eventLabelHeadlineClick: `certifiedsuper | headline | {{headline}}`,
      eventLabelView: `certifiedsuper | Discover Certified Super Food outlets`,
    },
  },

  data: [
      {
        image: "https://www.airasia.com/aa/images/web-apps/supersale-2023/jul/th/112_skincare.png",
        title: "ผลิตภัณฑ์ดูแลผิวหน้า",
        url: "https://www.airasia.com/shop/th/th/category/skincare",
        newTab: "TRUE"
      },
      {
         image: "https://www.airasia.com/aa/images/web-apps/supersale-2023/jul/th/112_fashion.png",
         title: "แฟชั่น",
         url: "https://www.airasia.com/shop/th/th/category/fashion",
          newTab: "TRUE"
      },
      {
         image: "https://www.airasia.com/aa/images/web-apps/supersale-2023/jul/th/112_makeup.png",
         title: "เครื่องสำอางค์",
         url: "https://www.airasia.com/shop/th/th/category/make-up",
          newTab: "TRUE"
      },
      {
         image: "https://www.airasia.com/aa/images/web-apps/supersale-2023/jul/th/112_hair.png",
         title: "ดูแลเส้นผมและผิวกาย",
         url: "https://www.airasia.com/shop/th/th/category/hair-and-body",
          newTab: "TRUE"
      },
      {
         image: "https://www.airasia.com/aa/images/web-apps/supersale-2023/jul/th/112_electronic.png",
         title: "เครื่องใช้ไฟฟ้าและอุปกรณ์อิเล็กทรอนิกส์",
         url: "https://www.airasia.com/shop/th/th/category/electronics",
          newTab: "TRUE"
      },
      {
         image: "https://www.airasia.com/aa/images/web-apps/supersale-2023/jul/th/112_food.png",
         title: "อาหารและเครื่องดื่ม",
         url: "https://www.airasia.com/shop/th/th/category/food",
          newTab: "TRUE"
      },
      {
         image: "https://www.airasia.com/aa/images/web-apps/supersale-2023/jul/th/112_health.png",
         title: "สุขภาพและความงาม",
         url: "https://www.airasia.com/shop/th/th/category/health-and-wellness",
          newTab: "TRUE"
      },
      {
         image: "https://www.airasia.com/aa/images/web-apps/supersale-2023/jul/th/112_airasiaexclusive.png",
         title: "แอร์เอเชีย เอ็กซ์คลูซีฟ",
         url: "https://www.airasia.com/shop/th/th/category/airasia-exclusives",
          newTab: "TRUE"
      }
    ]
  }
